import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as actionsCreators from "actions/topic";
import { Card } from "antd";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

class RightNews extends Component {

  componentDidMount() {
    this.props.topicRec();
  }

  render() {
    let { topicRec } = this.props.topic;
    return (
      <div className="right">
        <Card title="推荐" size="small">
          <ul className="topicrec">
            {topicRec
              ? topicRec.map(item => (
                  <li key={item.topic_id}>
                    <Link to={`/subject/${item.topic_id}`}>
                      <span>{item.topic_content.length>14?item.topic_content.slice(0,14)+'...':item.topic_content}</span>
                      <span>{moment(item.topic_datetime).format('YY-MM-DD')}</span>
                    </Link>
                  </li>
                ))
              : null}
          </ul>
        </Card>
      </div>
    );
  }
}

export default connect(
  state => state,
  dispatch => bindActionCreators(actionsCreators, dispatch)
) (RightNews);
